module.exports = __webpack_public_path__ + "static/rocket-launch-6ea394293e787f7cb71cb0c90ada80df.webp";